import {IndustryClass} from '../../domain/industry.domain';

export type SubdivisionIndustrySelectionValue = IndustryClass | null;
